import { Controller } from 'stimulus';

const EXPAND_ALL_EVENT = 'billable-item:expand-all';
const COLLAPSE_ALL_EVENT = 'billable-item:collapse-all';

export default class extends Controller {
  static targets = ['button', 'label'];

  connect() {
    this.sync();
  }

  toggle(event) {
    event.preventDefault();

    const eventName = this.#detailsState().allExpanded ? COLLAPSE_ALL_EVENT : EXPAND_ALL_EVENT;
    document.dispatchEvent(new CustomEvent(eventName));
    this.sync();
  }

  sync = () => {
    const { allExpanded, count } = this.#detailsState();
    const label = allExpanded ? 'Collapse All' : 'Expand All';

    this.buttonTarget.classList.toggle('hide', count <= 1);
    this.labelTarget.textContent = label;
  };

  #detailsState() {
    const itemToggles = Array.from(this.element.querySelectorAll('.billable-item__expand-toggle'));
    const sectionToggles = Array.from(
      this.element.querySelectorAll('.billable-section__collapse-toggle')
    );
    const toggles = [...itemToggles, ...sectionToggles];

    return {
      count: itemToggles.length,
      allExpanded:
        toggles.length > 0 &&
        toggles.every((toggle) => toggle.getAttribute('aria-expanded') === 'true'),
    };
  }
}
